import React, { Component } from "react";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import ErrorModal from "../../Fragments/ErrorModal";
import { OTPInput } from "../../UIComponents/UIComponents";

class MobStepTwo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: false,
      code: "",
      formResponse: "",
      showErrorModal: false,
    };

    // Timer related
    this.timeout = null;
    this.lifeTimeCounter = this.lifeTimeCounter.bind(this);
  }

  componentDidMount() {
    if (this.timeout === null) {
      this.lifeTimeCounter();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  lifeTimeCounter() {
    let seconds = this.props.forgotConfig.mobileTimeLife;

    seconds--;

    // Update parent component's state so that the value is shared across steps
    this.props.updateParentState({
      mobileTimeLife: seconds,
    });

    if (seconds > -1) {
      this.timeout = setTimeout(this.lifeTimeCounter, 1000);
    }
  }

  sendData(event) {
    this.setState({ buttonDisabled: true });

    ApiManager.postRequest(
      {
        code: this.state.code,
        token: this.props.forgotConfig.token,
        _token: this.props.csrf_token.data,
      },
      "/forgot-password/mob/confirm"
    ).then(
      (resolve) => {
        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.hasOwnProperty("token")) {
          this.props.updateParentState({
            step: 3,
            token: resolve.data.token,
          });
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );

    event.preventDefault();
  }
  lifeTimeConvert() {
    let seconds = this.props.forgotConfig.mobileTimeLife,
      minutes = Math.floor(seconds / 60);

    if (seconds / 60 < 1) {
      minutes = "00";
    }

    if (minutes < 10 && minutes > 0) {
      minutes = "0" + minutes;
    }

    if (seconds > 60) {
      seconds = seconds - minutes * 60;
    }

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ":" + seconds;
  }
  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    let errorCodeClass = "",
      errorCodeBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("code")) {
          errorCodeClass = " form-error";
          errorCodeBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.code}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={this.state.formResponse.errors.token}
            />
          );
        }
      }

      if (this.state.formResponse.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError
            message={this.state.formResponse.message}
            trans={this.props.trans}
          />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => this.sendData(event)}
        >
          <div className="form__form-box">
            <label className="form__label db fs11" htmlFor="tel-number">
              {trans(this.props.trans, "auth.forgot.password.mob.code.label1")}
            </label>
            <div className="form__field-out">
              <input
                className="form__field fs13"
                id="tel-number"
                name="tel-number"
                type="text"
                disabled="disabled"
                value={this.props.forgotConfig.userName}
              />
            </div>
          </div>

          <div className={`form__form-box${errorCodeClass}`}>
            <label className="form__label db fs11" htmlFor="code">
              {trans(this.props.trans, "auth.forgot.password.mob.code.label2")}
            </label>
            <div className="form__field-out pr">
              <OTPInput
                fields={6}
                id="code"
                type="text"
                name="code"
                value={this.state.code}
                onChange={(event) => {
                  this.setState({
                    code: event.trim().replace(/[^\d]/g, ""),
                  });
                }}
              />
            </div>
            {errorCodeBox}
          </div>
          <div className="form__form-box form__form-box--with-space form-box">
            <div className="form__time fs41 tc">{this.lifeTimeConvert()}</div>
          </div>
          {errorBox}

          <button
            className={`form__registration-btn btn btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "auth.forgot.password.button.title2")}
          </button>
        </form>
        {this.errorModal()}
      </div>
    );
  }
}

export default MobStepTwo;
